
export class OfferNavigationModule {
    private tabLinks: NodeListOf<Element>;
    private scrolledLists: NodeListOf<Element>;
    private defaultDraggables: NodeListOf<HTMLElement>;
    private leftArrow: HTMLElement;
    private rightArrow: HTMLElement;
    private leftArrowTab: HTMLElement;
    private rightArrowTab: HTMLElement;
    private currentTabContent: HTMLElement;
    private currentTab: HTMLElement;

    constructor() {
    }

    init(){

        this.currentTab = document.querySelector('.offer__navigation__tabs ul') as HTMLElement;

        this.leftArrow = document.querySelector('.offer__navigation__arrow-left')
        this.rightArrow = document.querySelector('.offer__navigation__arrow-right')
        this.leftArrowTab = document.querySelector('.offer__navigation__arrow-tab-left')
        this.rightArrowTab = document.querySelector('.offer__navigation__arrow-tab-right')
        this.tabLinks = document.querySelectorAll('.offer__navigation__tab__link');
        this.currentTabContent = document.querySelector('.offer__navigation__tabcontent.current,.offer__navigation__tabcontent.active') as HTMLElement;
        // this.tabLinks.forEach((link,index) => {
        //     link.addEventListener('click', (e) => {
        //         const currentLink = e.currentTarget as HTMLElement;
        //         this.removeAllClasses();
        //         const linkDataId = currentLink.dataset.tab;
        //         const tabContentEl = document.querySelector(`.offer__navigation__tabcontent[data-tab=\"${linkDataId}"]`) as HTMLElement;
        //         this.currentTabContent = tabContentEl;
        //         tabContentEl.classList.add('active');
        //         // currentLink.classList.add('active')
        //         currentLink.classList.add('opened');
        //         this.checkArrows();
        //
        //     })
        // })

        this.scrolledLists = document.querySelectorAll('.offer__navigation__content ul, .offer__navigation__tabs ul');

        let mouseX = 0;
        let initialMouseX = 0;
        let draggedList: null|HTMLElement = null;

        const mouseDownHandler = function(e: MouseEvent) {
            if (e.button !== 0) {
                return;
            }
            initialMouseX = mouseX = e.clientX;

            draggedList = this;
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('click', mouseUpHandler);
            draggedList.style.userSelect = 'none';
        };

        const mouseMoveHandler = function(e: MouseEvent) {
            const dy = mouseX - e.clientX;
            draggedList.scrollLeft += dy;
            mouseX = e.clientX;
        };

        const mouseUpHandler = function(e: MouseEvent) {

            if (Math.abs(mouseX - initialMouseX) > 10) {
                e.preventDefault();
            }

            draggedList.style.removeProperty('user-select');
            draggedList = null;
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('click', mouseUpHandler);
        };

        const wheelHandler = function(e: WheelEvent) {
            const x = e.deltaX;
            const y = e.deltaY;
            const d = e['delta' + (Math.abs(x) > Math.abs(y) ? 'X' : 'Y')];

            if (
                (d < 0 && this.scrollLeft > 0) ||
                // @ts-ignore
                (d > 0 && this.scrollLeft + this.offsetWidth < this.scrollWidth)
            ) {
                e.preventDefault();
            }

            this.scrollLeft += d;

        }

        this.scrolledLists.forEach((list,index) => {
            list.addEventListener('mousedown', mouseDownHandler);
            list.addEventListener('wheel', wheelHandler);
            list.addEventListener('scroll', () => list.parentElement.classList.contains('offer__navigation__tabs') ? this.checkArrowsTab() : this.checkArrows())
        })

        if (this.leftArrow) {
            this.leftArrow.addEventListener('click', () => {
                this.currentTabContent.scroll({
                    left: this.currentTabContent.scrollLeft - Math.max(300, (this.currentTabContent.clientWidth / 2)),
                    behavior: 'smooth'
                });
            });
        }

        if (this.rightArrow) {
            this.rightArrow.addEventListener('click', () => {
                this.currentTabContent.scroll({
                    left: this.currentTabContent.scrollLeft + Math.max(300, (this.currentTabContent.clientWidth / 2)),
                    behavior: 'smooth'
                });
            });
        }

        if (this.leftArrowTab) {
            this.leftArrowTab.addEventListener('click', () => {
                this.currentTab.scroll({
                    left: this.currentTab.scrollLeft - Math.max(300, (this.currentTab.clientWidth / 2)),
                    behavior: 'smooth'
                });
            });
        }

        if (this.rightArrowTab) {
            this.rightArrowTab.addEventListener('click', () => {
                this.currentTab.scroll({
                    left: this.currentTab.scrollLeft + Math.max(300, (this.currentTab.clientWidth / 2)),
                    behavior: 'smooth'
                });
            });
        }

        window.addEventListener('resize', () => {
            this.checkArrows();
            this.checkArrowsTab();
        })

        // setTimeout(() => {
            this.scrollToCurrentElement();
        // }, 0);

        this.preventUnwantedDragging();

        this.checkArrows();
        this.checkArrowsTab();

    }

    checkArrowsTab() {

        if (!this.leftArrowTab || !this.rightArrowTab) {
            return;
        }

        if (this.currentTab.clientWidth >= this.currentTab.scrollWidth) {
            this.leftArrowTab.style.display = 'none';
            this.rightArrowTab.style.display = 'none';
            return;
        }

        this.leftArrowTab.style.display = this.currentTab.scrollLeft > 0 ? 'flex' : 'none';
        this.rightArrowTab.style.display = ((this.currentTab.scrollLeft + this.currentTab.clientWidth) < this.currentTab.scrollWidth) ? 'flex' : 'none';

    }

    checkArrows() {

        if (!this.leftArrow || !this.rightArrow) {
            return;
        }

        if (!this.currentTabContent || this.currentTabContent.clientWidth >= this.currentTabContent.scrollWidth) {
            this.leftArrow.style.display = 'none';
            this.rightArrow.style.display = 'none';
            return;
        }

        this.leftArrow.style.display = this.currentTabContent.scrollLeft > 0 ? 'flex' : 'none';
        this.rightArrow.style.display = ((this.currentTabContent.scrollLeft + this.currentTabContent.clientWidth) < this.currentTabContent.scrollWidth) ? 'flex' : 'none';

    }

    removeAllClasses(){
        const allTabLinks = document.querySelectorAll(".offer__navigation__tab__link");
        allTabLinks.forEach((tabLink) => {
            // tabLink.classList.remove("active")
            // tabLink.classList.remove("current")
            tabLink.classList.remove("opened")
        });
        const allTabsContent = document.querySelectorAll(".offer__navigation__tabcontent");
        allTabsContent.forEach((tabContent) => {
            tabContent.classList.remove("active")
            tabContent.classList.remove("current")
        })
    }


    scrollToCurrentElement() {
        const currentTabLink = document.querySelector('.offer__navigation__tab__link.current,.offer__navigation__tab__link.active') as HTMLElement;
        const currentContentLink = document.querySelector('.offer__navigation__content__link.current') as HTMLElement;

        console.log('scroll into view', currentTabLink, currentContentLink);

        if (currentTabLink || currentContentLink) {

            // const windowScrollX = window.scrollX;
            // const windowScrollY = window.scrollY;

            if (currentTabLink) {
                console.log('scroll into view scrolling tab');
                const tabContainer = currentTabLink.closest('ul');
                tabContainer.scrollLeft = currentTabLink.offsetLeft - (tabContainer.clientWidth / 2) + (currentTabLink.clientWidth / 2);
                // currentTabLink.scrollIntoView({inline: "center"});
            }

            if (currentContentLink) {
                console.log('scroll into view scrolling content');
                const contentContainer = currentContentLink.closest('ul');
                contentContainer.scrollLeft = currentContentLink.offsetLeft - (contentContainer.clientWidth / 2) + (currentContentLink.clientWidth / 2);

                // currentContentLink.scrollIntoView({inline: "center"});
            }

            // window.scrollTo(windowScrollX, windowScrollY);

        }

    }

    preventUnwantedDragging() {
        this.defaultDraggables = document.querySelectorAll('.offer__navigation a, .offer__navigation img');
        this.defaultDraggables.forEach((elem,index) => {
            elem.addEventListener('dragstart', (e) => {
                e.preventDefault();
            });
        })
    }

}
